<template>
  <div class="d-inline">
    <b-dropdown v-if="finalAction.length > 2" class="m-md-2 contract-dropshown" boundary="body">
      <b-dropdown-item v-for="(action, i) in finalAction" :key="i" @click="action.action">
        <i v-if="action.icon" :class="action.icon"></i> {{ action.text }}
      </b-dropdown-item>
    </b-dropdown>
    <b-button-group v-else>
      <b-button
        v-for="(action, i) in finalAction"
        :key="i"
        @click="action.action"
        v-b-tooltip.hover="{ delay: { show: 300 } }"
        variant="outline-secondary"
        size="sm"
        :title="action.text"
      >
        <i v-if="action.icon" :class="action.icon" class="p-0"></i>
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
  export default {
    props: ['actions', 'excepts', 'only'],
    data() {
      return {}
    },
    computed: {
      finalAction() {
        if (this.only.length > 0)
          return (
            this.actions.filter(
              s => this.have(s.code) && (s.condition === true || s.condition === undefined)
            ) ?? []
          )
        return (
          this.actions.filter(
            s => this.without(s.code) && (s.condition === true || s.condition === undefined)
          ) ?? []
        )
      },
    },
    async created() {},
    methods: {
      without(code) {
        return !this.excepts?.includes(code)
      },
      have(code) {
        return this.only?.includes(code)
      },
    },
  }
</script>

<style scoped></style>
